import styled, { css } from 'styled-components';
import { variant } from 'styled-system';

import { ThemeUtilities } from '../../../theme';
import { ComponentSize } from '../types';
import { Status, Variant } from './types';
import { fontSmoothing } from '../../../mixins';

export const StyledInput = styled.input<{
  inputSize: ComponentSize;
  hasIconLeft: boolean;
  hasIconRight: boolean;
  variant: Variant;
  status: Status;
  fullWidth: boolean;
}>`
  border: 1px solid currentColor;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  ${fontSmoothing};

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `};

  transition: border-color 250ms ease-in-out, box-shadow 250ms ease-in-out,
    background-color 250ms ease-in-out;
  will-change: border-color, box-shadow, background-color;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Input', 'inputSize'))};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Input', 'variant'))};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Input', 'status'))};

  ${({ hasIconLeft, inputSize, theme }) =>
    hasIconLeft &&
    css`
      padding-left: ${theme.space[
        theme.components.Input.componentVariants.inputSize.variants[inputSize]
          .paddingLeft
      ] +
      theme.sizes[
        theme.components.Input.componentVariants.iconSize.variants[inputSize]
          .width
      ] +
      theme.sizes[0]}px;
    `};
  ${({ hasIconRight, inputSize, theme }) =>
    hasIconRight &&
    css`
      padding-right: ${theme.space[
        theme.components.Input.componentVariants.inputSize.variants[inputSize]
          .paddingRight
      ] +
      theme.sizes[
        theme.components.Input.componentVariants.iconSize.variants[inputSize]
          .width
      ] +
      theme.sizes[0]}px;
    `};

  ${css((props) => ThemeUtilities.getComponentCSSOverrides(props, 'Input'))};
`;

export const Container = styled.div`
  position: relative;
`;

export const IconContainer = styled.div<{
  iconSize: ComponentSize;
  hasIconLeft?: boolean;
  hasIconRight?: boolean;
}>`
  display: flex;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Input', 'iconSize'))};

  ${({ hasIconLeft, iconSize, theme }) =>
    hasIconLeft &&
    css`
      left: ${theme.space[
        theme.components.Input.componentVariants.inputSize.variants[iconSize]
          .paddingLeft
      ]}px;
      right: auto;
    `};

  ${({ hasIconRight, iconSize, theme }) =>
    hasIconRight &&
    css`
      right: ${theme.space[
        theme.components.Input.componentVariants.inputSize.variants[iconSize]
          .paddingRight
      ]}px;
      left: auto;
    `};
`;
